module.exports = __webpack_public_path__ + "static/media/brand1-large.b6d56c6e.jpg";